import { render, staticRenderFns } from "./setPrize.vue?vue&type=template&id=cdccd7b6&scoped=true&"
import script from "./setPrize.vue?vue&type=script&lang=js&"
export * from "./setPrize.vue?vue&type=script&lang=js&"
import style0 from "./setPrize.vue?vue&type=style&index=0&id=cdccd7b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdccd7b6",
  null
  
)

export default component.exports